import { IconProp } from '@fortawesome/fontawesome-svg-core';
// import { faHourglassHalf } from '@fortawesome/free-regular-svg-icons';
import {
  Icon,
  //UilChartPie,
  UilCube,
  //UilDocumentLayoutRight,
  // UilFilesLandscapesAlt,
  //UilPuzzlePiece,
  //UilPricetagAlt,
  UilWrench
} from '@iconscout/react-unicons';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
  visible?: boolean;
}

export const routes: RouteItems[] = [
  {
    label: 'My NuPitch',
    horizontalNavLabel: 'My NuPitch',
    active: true,
    icon: UilCube,
    pages: [
      {
        name: 'My projects',
        icon: 'codesandbox',
        path: '/apps/project-management/project-board-view',
        pathName: 'project-management-project-board-view',
        active: true
      },
      {
        name: 'create new',
        icon: 'zap',
        path: '/apps/project-management/create-new',
        pathName: 'project-management-create-new',
        active: true
      }
      // {
      //   name: 'Templates',
      //   icon: 'layers',
      //   path: '/apps/project-management/template-board-view',
      //   pathName: 'project-management-template-board-view',
      //   active: true
      // },
      // {
      //   name: 'Analytics',
      //   icon: 'sliders',
      //   path: '/apps/project-management/project-analytics',
      //   pathName: 'project-management-project-analytics',
      //   active: true
      // }
    ]
  },
  {
    label: 'admin',
    icon: UilWrench,
    active: true,
    pages: [
      {
        name: 'members',
        icon: 'users',
        path: '/apps/project-management/admin/members',
        pathName: 'members',
        active: true
      },
      {
        name: 'All Projects',
        icon: 'projects',
        path: '/apps/project-management/admin/projects',
        pathName: 'members',
        active: true
      }
    ]
  }
];
